/**
 * Learn more about using TypeScript with React Navigation:
 * https://reactnavigation.org/docs/typescript/
 */

import { BottomTabScreenProps } from '@react-navigation/bottom-tabs';
import { CompositeScreenProps, NavigatorScreenParams } from '@react-navigation/native';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { BillPaymentStackParamList } from './features/bill-payment/payment.navigator';
import { EarnStackParamList } from './features/earn';
import { ExchangeSubAccountStackParamList } from './features/exchange-sub-account/exchange.navigator';
import { AccountManagementStackParamList } from './features/account-management/account.navigator';
import { CardAccountStackParamList } from './features/card-account/card.navigator';

declare global {
  namespace ReactNavigation {
    interface RootParamList extends RootStackParamList {}
  }
}

export enum RootStackRoutes {
  Root = 'root',
  DevTools = 'devtools',
  Main = 'main',
  Earn = 'earn',
  Init = 'initial',
  ExchangeSubAccount = 'exchange-sub-account',
  AccountManagement = 'account-management',
  CardAccount = 'card-account',
  BillPayment = 'bill-payment'
}

export enum RootTabRoutes {
  Dev = 'dev'
}

export type RootStackScreenProps<Screen extends keyof RootStackParamList> = NativeStackScreenProps<RootStackParamList, Screen>;

export type RootTabParamList = {
  [RootTabRoutes.Dev]: undefined;
};

export type RootStackParamList = {
  [RootStackRoutes.Root]: undefined;
  [RootStackRoutes.DevTools]: undefined;
  [RootStackRoutes.Main]: NavigatorScreenParams<RootTabParamList> | undefined;
  [RootStackRoutes.Earn]: NavigatorScreenParams<EarnStackParamList> | undefined;
  [RootStackRoutes.Init]: {
    authToken: string;
  };
  [RootStackRoutes.ExchangeSubAccount]: NavigatorScreenParams<ExchangeSubAccountStackParamList> | undefined;
  [RootStackRoutes.AccountManagement]: NavigatorScreenParams<AccountManagementStackParamList> | undefined;
  [RootStackRoutes.CardAccount]: NavigatorScreenParams<CardAccountStackParamList> | undefined;
  [RootStackRoutes.BillPayment]: NavigatorScreenParams<BillPaymentStackParamList> | undefined;
};

export type RootTabScreenProps<Screen extends keyof RootTabParamList> = CompositeScreenProps<
  BottomTabScreenProps<RootTabParamList, Screen>,
  NativeStackScreenProps<RootStackParamList>
>;
